import { formatInTimeZone } from 'date-fns-tz/formatInTimeZone'
import { addMilliseconds } from 'date-fns/addMilliseconds'
import { isAfter } from 'date-fns/isAfter'
import { isBefore } from 'date-fns/isBefore'
import { isValid } from 'date-fns/isValid'
import { enGB } from 'date-fns/locale/en-GB'
import { parseISO } from 'date-fns/parseISO'

export function formatDateText(date: Date, timezone: string): string {
  if (!isValid(date)) return 'Invalid date'
  const selectedDay = formatInTimeZone(date, timezone, 'yyyy-MM-dd')
  const today = formatInTimeZone(new Date(), timezone, 'yyyy-MM-dd')
  // Advance the calendar label in UTC, independent of browser or location DST.
  const tomorrow = formatInTimeZone(
    addMilliseconds(parseISO(`${today}T00:00:00Z`), 24 * 60 * 60 * 1000),
    'UTC',
    'yyyy-MM-dd',
  )
  if (selectedDay === today) return 'Today'
  if (selectedDay === tomorrow) return 'Tomorrow'
  return formatInTimeZone(date, timezone, 'eee do MMM', { locale: enGB })
}

export function isServiceTimeOpen(
  openTime: string | null | undefined,
  closeTime: string | null | undefined,
  now = new Date(),
): boolean {
  if (!openTime || !closeTime) return false
  return isAfter(now, parseISO(openTime)) && isBefore(now, parseISO(closeTime))
}
